import { InjectionToken } from '@angular/core';

export const HORIZONTAL_PARENT = new InjectionToken('Horizontal Parent Component');
